// API.ts
// This file contains all the endpoints needed for the backoffice application

export const API = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
    FEDERATIONS: '/auth/federations',
    SELECT_FEDERATION: '/auth/select-federation',
    LEAVE_FEDERATION: '/auth/leave-federation',
  },
  PLATFORM: {
    FEDERATIONS: '/api/platform/federations',
    USERS: '/api/platform/users',
    ROLES: '/api/platform/roles',
  },
  FEDERATION: {
    GET_ME: '/api/federations/me',
    GET_DETAIL: '/api/federations/:id',
    COMPAGNES_LIST: '/api/compagnes',
  },
  CLUB: {
    ALL: '/api/clubs/all',
    LIST_BY_FEDERATION: '/api/clubs/list',
    STATS_FEDERATION: '/api/clubs/stats',
  },
  JOUEURS: {
    LIST_BY_FEDERATION: '/api/joueurs/list',
    STATS_FEDERATION: '/api/joueurs/stats',
  },
  MANAGERS: {
    LIST_BY_FEDERATION: '/api/managers/list',
    STATS_FEDERATION: '/api/managers/stats',
  },
  STAFF: {
    LIST_BY_FEDERATION: '/api/staff/list',
    STATS_FEDERATION: '/api/staff/stats',
  },
  REFEREES: {
    LIST_BY_FEDERATION: '/api/referees/list',
    STATS_FEDERATION: '/api/referees/stats',
  },
  CODIFICATIONS: {
    GET_BY_GROUP: '/api/codifications',
  },
  SEASONS: {
    LIST: '/api/seasons',
  },
  LICENCES: {
    GENERATE: '/api/licences/generate',
    GENERATE_ALL: '/api/licences/generate-all',
    GENERATE_ALL_STREAM: (entityType: string) => `/api/licences/generate-all-stream?entity_type=${entityType}`,
    CANCEL_STREAM: '/api/licences/generate-all-cancel',
    PDF_STATUS: (demandeId: number, entityType: string) => `/api/licences/pdf-status/${demandeId}?entity_type=${entityType}`,
    PLAYER_PDF: (demandeId: number) => `/api/licences/player/${demandeId}/pdf`,
    DOWNLOAD_PDF: (demandeId: number, entityType: string) => `/api/licences/${demandeId}/pdf?entity_type=${entityType}`,
    REGENERATE_PDF: '/api/licences/regenerate-pdf',
    REGENERATE_ALL_STREAM: (entityType: string) => `/api/licences/regenerate-all-stream?entity_type=${entityType}`,
    CANCEL_REGENERATE_STREAM: '/api/licences/regenerate-all-cancel',
    SPECIMEN: '/api/licences/specimen',
    // Fiche licences (real-data lists)
    LIST: '/api/licences/list',
    FICHE_PDF: (id: number, entityType: string) => `/api/licences/fiche-pdf?entity_type=${entityType}&id=${id}`,
    REGENERATE_FROM_FICHE: '/api/licences/regenerate-from-fiche',
    REGENERATE_BULK: '/api/licences/regenerate-bulk',
    REGENERATE_FICHE_STREAM: (qs: string) => `/api/licences/regenerate-fiche-stream?${qs}`,
    CANCEL_REGEN_FICHE: '/api/licences/regenerate-fiche-cancel',
    MARK_PRINTED: '/api/licences/mark-printed',
    EXPORT_ZIP: '/api/licences/export-zip',
  },
  MENU_MANAGER: {
    GET_ALL:     '/api/menu_manager/get_all',
    UPDATE:      '/api/menu_manager/update',
    SET_DEFAULT: '/api/menu_manager/set_default',
  },
  FORMULAIRES: {
    LIST: '/api/formulaires',
    GET_BY_ID: '/api/formulaires',        // + /:id
    CREATE: '/api/formulaires',
    UPDATE: '/api/formulaires',           // + /:id
    UPLOAD: '/api/formulaires',           // + /:id/upload
    VARIABLES: '/api/formulaires/variables',
    HEADER: '/api/formulaires/header',    // GET/PUT config ; + /image/:slot upload/delete
  },
};
